import React from "react";

export default function MarksList({ marks, selectedId, setSelectedId }) {
  return (
    <div className="tricho-list">
      {marks.map((m, idx) => (
        <button
          key={m.id}
          className={selectedId === m.id ? "tricho-list-item tricho-list-item--active" : "tricho-list-item"}
          onClick={() => setSelectedId(m.id)}
          type="button"
        >
          <div className="tricho-list-item__left">
            <div className="tricho-chip">{idx + 1}</div>
            <div className="tricho-list-item__meta">
              <div className="tricho-list-item__title">Marcação</div>
              <div className="tricho-list-item__sub">
                x:{Math.round(m.rect.x)} y:{Math.round(m.rect.y)} w:{Math.round(m.rect.w)} h:{Math.round(m.rect.h)}
              </div>
            </div>
          </div>

          {typeof m.score === "number" && m.score < 1 && (
            <div className="tricho-score-pill">{m.score.toFixed(2)}</div>
          )}
        </button>
      ))}
    </div>
  );
}
